var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

import color from 'color';

export var makeColorFn = function makeColorFn() {
  var _color$rgb$array = color.apply(undefined, arguments).rgb().array(),
      _color$rgb$array2 = _slicedToArray(_color$rgb$array, 3),
      r = _color$rgb$array2[0],
      g = _color$rgb$array2[1],
      b = _color$rgb$array2[2];

  var c = function c() {
    var opacity = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
    return 'rgba(' + r + ', ' + g + ', ' + b + ', ' + opacity + ')';
  };
  c.toString = function () {
    return 'rgb(' + r + ', ' + g + ', ' + b + ')';
  };
  return c;
};
export var TSS_DARK_BLUE = makeColorFn('#312E51');
export var TSS_GREEN = makeColorFn('#99CC00');
export var TSS_GREEN_1 = makeColorFn('#F5F7F0');
export var TSS_ORANGE = makeColorFn('#FF9933');
export var TSS_ORANGE_2 = makeColorFn('#FAF8F2');
export var TSS_BLUE = makeColorFn('#66CCFF');
export var TSS_BLUE_1 = makeColorFn('#ECF1F3');
export var TSS_BLUE_2 = makeColorFn('#FAFBFC');
export var TSS_RED = makeColorFn('#FF3333');
export var TSS_BLACK = makeColorFn('#242424');
export var TSS_GRAY = makeColorFn('#9FACB1');